import { isMobile, isTablet } from "react-device-detect";
import { getStoredUtmParams } from "./useUtmTracking";

// Holds the GA client id that has already been used for a transaction request.
// When the same id comes back on a later visit we know this is a returning user.
const SEEN_COOKIE_ID_KEY = "GA_COOKIE_ID_SEEN";

const RETURNING_SUFFIX = "_rt";

/**
 * Builds the transaction_campaign value for the get-transaction-id call.
 *
 * First visit for a given cookieId keeps the existing value. Every later visit
 * with that same cookieId gets "_rt" appended so returning users are
 * identifiable on the campaign side.
 *
 * @param {string|null|undefined} cookieId GA client id from localStorage.
 * @param {boolean} [useUtm=true] Whether a stored utm_campaign may override the default.
 */
export const buildTransactionCampaign = (cookieId, useUtm = true) => {
    const base =
        (useUtm ? getStoredUtmParams()?.utm_campaign : null) ||
        (isMobile || isTablet ? "GeniusMobile" : "GeniusWebsite");

    // Without a cookieId (e.g. consent declined) we cannot tell visits apart,
    // so treat it as a first visit and leave the marker untouched.
    if (!cookieId) return base;

    const isReturning = localStorage.getItem(SEEN_COOKIE_ID_KEY) === cookieId;
    if (!isReturning) {
        localStorage.setItem(SEEN_COOKIE_ID_KEY, cookieId);
        return base;
    }

    return `${base}${RETURNING_SUFFIX}`;
};
